<script>
import {humanizeDate} from "@/filters/momentTzConvert";
import {mapState} from "vuex";
import UploadFileButton from "@components/file-multiple-input/upload-file-button.vue";

export default {
  name: "index",
  components: {UploadFileButton},
  data: () => ({
    reports: [],
    showModal: false,
    showCancellationReport: false,
    showUploadResponse: false,
    modalData: [],
    cancellationForm: {
      pids: ''
    }
  }),
  computed: {
    ...mapState("auth", ["user"]),
  },
  filters: {
    humanize: humanizeDate
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.$vs.loading();

      const {data} = await axios.get(`/api/rug/reports`);
      this.reports = data;
      this.$vs.loading.close();
    },
    translateStatus(status) {
      return (status === 'created') ? 'Creado' : 'Subido';
    },
    translateType(type) {
      return (type === 'cancellation') ? 'Cancelación' : 'Inscripción';
    },
    showDetailsHandler(item) {
      this.showModal = true;
      this.modalData = item.project_with_error;
    },
    async generateCancellationReportHandler() {
      this.$vs.loading();
      const pids = this.cancellationForm.pids.split(",")
      try {
        await axios.post(`/api/rug/report/unsubscription`, {pids})

        this.$vs.loading.close();
        this.showCancellationReport = false;
        this.$vs.notify({
          title: 'Reporte generado',
          text: 'El reporte de cancelación se ha generado correctamente',
          color: 'success'
        });

        fetchData();
      } catch (e) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: 'Error',
          text: 'Ocurrió un error al generar el reporte de cancelación',
          color: 'danger'
        });
      }
    },
    uploadFileSuccess() {
      this.fetchData();
    }
  }
}
</script>

<template>
  <div class="container mt-10">
    <div class="flex justify-end mb-5">
      <vs-button color="danger" class="small" @click="showCancellationReport = true">
        Generar reporte de cancelación
      </vs-button>
    </div>
    <vx-card title="Reportes RUG">
      <vs-table stripe pagination :data="reports">
        <template slot="thead">
          <vs-th>Id</vs-th>
          <vs-th>Tipo de reporte</vs-th>
          <vs-th>Estado de reporte</vs-th>
          <vs-th>Archivos</vs-th>
          <vs-th>Total creados</vs-th>
          <vs-th>F. creación</vs-th>
          <vs-th>Opciones</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr v-for="item in data" :key="item.id">
            <vs-td>{{ item.id }}</vs-td>
            <vs-td class="text-xs">
               <span class="text-white px-2 rounded bg-gray" :class="{
                    'bg-success': item.type === 'inscription',
                    'bg-danger': item.type === 'cancellation'
                  }">
                    {{ translateType(item.type) }}
                  </span>
            </vs-td>
            <vs-td class="text-xs">
              <span class="text-white px-2 rounded" :class="{
                    'bg-info': item.status === 'created',
                    'bg-success': item.status === 'uploaded'
                  }">
                    {{ translateStatus(item.status) }}
                  </span>
            </vs-td>
            <vs-td class="text-xs">
              <div class="flex flex-col gap-2">
                <div>
                  <a
                      class="bg-dark text-white p-2 rounded cursor-pointer"
                      :href="`${ApiDomain}/api/rug/report/${item.id}/download?type=base&access_token=${user.access_token}`"
                      target="_blank">
                    <vs-icon icon="download"></vs-icon>
                    Reporte de carga
                  </a>
                </div>
                <div class="mt-2">
                  <a
                      class="bg-dark text-white p-2 rounded cursor-pointer"
                      v-if="item.status === 'uploaded'"
                      :href="`${ApiDomain}/api/rug/report/${item.id}/download?type=answer&access_token=${user.access_token}`"
                      target="_blank">
                    <vs-icon icon="download"></vs-icon>
                    Reporte de respuesta
                  </a>
                </div>
              </div>
            </vs-td>
            <vs-td>
              <span class="text-danger underline cursor-pointer" @click="showDetailsHandler(item)">
                {{ item.project_created }}/{{ item.total }}
              </span>
            </vs-td>
            <vs-td>{{ item.created_at | humanize }}</vs-td>
            <vs-td>
              <vs-tooltip title="Subir reporte de respuesta">
                <upload-file-button
                    @onFileUploaded="uploadFileSuccess"
                    size="small"
                    v-if="item.status !== 'uploaded'"
                    :data="{rug_report_id: item.id}"
                    server-uri="/api/rug/report/upload">
                  Subir reporte de respuesta
                </upload-file-button>
              </vs-tooltip>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>

    <vs-popup title="Detalles de proyectos con error" :active.sync="showModal">
      <pre>
        {{ modalData }}
      </pre>
    </vs-popup>

    <vs-popup title="Generar reporte de cancelación" :active.sync="showCancellationReport">
      <vs-input
          v-model="cancellationForm.pids"
          class="w-full" label="Pids separado por comas"></vs-input>

      <vs-button @click="generateCancellationReportHandler">
        Generar
      </vs-button>
    </vs-popup>

    <vs-popup title="Generar reporte de cancelación" :active.sync="showUploadResponse">
      <vs-input
          v-model="cancellationForm.pids"
          class="w-full" label="Pids separado por comas"></vs-input>

      <vs-button @click="generateCancellationReportHandler">
        Generar
      </vs-button>
    </vs-popup>
  </div>
</template>
